/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';
const AlertFormSuccess = {

	// $domFormSubmitBtn: $('input[type='submit'].js-submit-btn'),
	$domSuccessMessage: $('.js-success-message'),
	$domForm: $('.js-alert-form'),
	$domLoader: $('.js-alert-loader'),
	classShowMessage: 'success-subscribe',
	classHideForm: 'submitted',


	init: function() {
		this.submitted();
	},

	submitted: function() {
		this.$domForm.on('submit', function(event) {
			event.stopDefault();
			this.$domSuccessMessage.addClass(this.classShowMessage);
			($('.js-subscribe-email')).reset();
		});
	},
};

export default AlertFormSuccess;
